import React from 'react'
import { Field } from 'redux-form'
import { TextField, InputMaskField } from '@foodsby/nutrient'
import { length, required } from 'redux-form-validators/lib'
import { noSpacesAllowed } from '../../util/validators'

const UserInfo = ({ user }) => (
  <div className="row">
    <div className="col-xs-12 col-sm-6">
      <label htmlFor="email">Email</label>
      <p id="email" className="personalize-text">
        {user.email}
      </p>
    </div>
    <div className="col-xs-12 col-sm-6">
      <Field
        id="User.phone"
        name="User.phone"
        component={InputMaskField}
        type="text"
        mask="(999) 999-9999"
        label="Phone Number *"
        normalize={val => val.replace(/\D/g, '')}
        validate={[
          noSpacesAllowed,
          required({ msg: `Phone Number is required` }),
          length({
            is: 10,
            msg: { wrongLength: `Phone Number must be 10 digits` }
          })
        ]}
      />
    </div>
    <div className="col-xs-12 col-sm-6">
      <Field
        id="User.firstName"
        name="User.firstName"
        component={TextField}
        type="text"
        label="First Name *"
        maxLength="35"
        validate={[
          noSpacesAllowed,
          required({ msg: `First Name is required` })
        ]}
      />
    </div>
    <div className="col-xs-12 col-sm-6">
      <Field
        id="User.lastName"
        name="User.lastName"
        component={TextField}
        type="text"
        label="Last Name *"
        maxLength="35"
        validate={[noSpacesAllowed, required({ msg: `Last Name is required` })]}
      />
    </div>
  </div>
)
export default UserInfo
